module.exports = __webpack_public_path__ + "img/maipu-logo-blanco.7e5cb3ca.png";